<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal size="large"
           id="requestAccessProposalModal"
           :title="mode === 'create' ? 'Solicitação de Permissão de Acesso' : 'Solicitações pendentes'">

        <template v-slot:body>
            <div class="container-fluid-grid" slot="body">
                <div class="form-row" v-if="mode === 'create'">
                    <div class="col-12 form-group">
                        <label for="cancelProposalTextArea" class="required">Informe o motivo</label>

                        <textarea id="cancelProposalTextArea"
                                  maxlength="500"
                                  required
                                  :class="{'is-invalid': errors.description || errors.user_request_id}"
                                  v-model="entity.description"
                                  class="form-control form-control-sm"></textarea>
                        <field-messages :errors="errors.description"/>
                        <field-messages :errors="errors.user_request_id"/>
                    </div>
                </div>
                <div class="form-row" v-else>
                    <div class="col-12">
                        <table v-if="requests.length > 0" class="table table-sm table-responsive-sm">
                            <thead class="thead-dark thead-center">
                            <tr>
                                <th>Quem Solicitou</th>
                                <th>Solicitação</th>
                                <th>Quando</th>
                                <th style="width: 60px"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="req in requests">
                                <td class="v-m c-p t-c">{{req.user_request.name}}</td>
                                <td class="v-m c-p">{{req.description}}</td>
                                <td class="v-m c-p t-c">{{req.created_at | formatDateHourMin}}</td>
                                <td class="v-m t-c">
                                <span v-if="req.allow === null" class="btn-group btn-group-xs" role="group">
                                    <button type="button"
                                            :disabled="running"
                                            @click="change(true, req.id)"
                                            class="btn btn-success btn-xs">
                                        <svg-icon :icon="!running ? 'thumbs-up' : 'sync refresh rotate-1-seg'"/>
                                    </button>
                                    <button type="button"
                                            :disabled="running"
                                            @click="change(false, req.id)"
                                            class="btn btn-danger btn-xs">
                                        <svg-icon :icon="!running ? 'thumbs-down' : 'sync refresh rotate-1-seg'"/>
                                    </button>
                                </span>
                                    <span class="f-w-700" v-else>{{req.allow | bool2Human}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h3 v-else>Não há solicitações...</h3>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button"
                    v-if="mode === 'create'"
                    @click="save"
                    class="btn btn-sm btn-danger">
                <svg-icon icon="unlock"/>
                Solicitar
            </button>
            <button type="button"
                    @click="$emit('closeModal')"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>

    </modal>
</template>

<script>
    export default {
        name: "PermissionAccessModal",
        props: {
            mode: {
                type: String,
                default: 'create',
                validator: val => /(create|unlock)/gi.test(val)
            },
            id_reg: {
                type: Number
            }
        },
        data() {
            return {
                entity: {
                    id_reg: null,
                    table_type: 'proposals',
                    description: '',
                    opened: true,
                },
                running: false,
                requests: [],
                errors: {}
            }
        },
        methods: {
            save() {
                this.$appHttp.post('/v1/request_permission_access', {request_permission_access: {...this.entity}})
                    .then(() => {
                        this.$emit('closeModal');
                        this.$snotify.success('Solicitação realizada com sucesso!', this.$appStorage.getUser().name);
                    })
                    .catch(({response}) => {
                        this.$appUtils.vibrate(200);
                        if (response.status === 422) {
                            Object.keys(response.data).forEach(k => {
                                this.$set(this.errors, k, response.data[k]);
                            });
                            this.$snotify.warning('Verifique os dados informados', 'Validação');
                        } else if (response.status === 403) {
                            this.$snotify.error('Você não possui permissão para executar essa ação', 'Permissão')
                        } else {
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema na solicitação de permissão.'}), this.$appStorage.getUser().name);
                        }
                    })
            },
            change(isAllow, id) {
                this.running = true;

                const entity = {
                    allow: isAllow,
                    opened: false,
                    id: id
                };

                this.$appHttp.put(`/v1/request_permission_access/${id}`, {request_permission_access: {...entity}})
                    .then(({data}) => {
                        this.requests.changeObject(data);
                        this.$snotify.success(`${isAllow ? 'Permissão realizada' : 'Bloqueio realizado'} com sucesso!`, this.$appStorage.getUser().name);
                    })
                    .catch(err => {
                        this.$appUtils.vibrate(200);
                        console.error(err);
                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema na mudança de status da solicitação.'}), this.$appStorage.getUser().name);
                    })
                    .finally(() => this.running = false);
            }
        },
        mounted() {
            if (this.mode === 'unlock') {
                this.$appHttp.get(`/v1/request_permission_access?id_reg=${this.id_reg}`)
                    .then(({data}) => {
                        this.requests = data;
                    })
                    .catch(err => {
                        console.error(err);
                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar carregar as solicitações.'}), this.$appStorage.getUser().name);
                    });
            } else {
                this.entity.id_reg = this.id_reg;
            }
        }
    }
</script>
